import NewCompanyContacts from './components/NewCompanyContacts';

const CompanyContacts = () => {
  return (
    <>
      <NewCompanyContacts />
    </>
  );
};

export default CompanyContacts;
